module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "features address-info"
  }, [_c('div', {
    staticClass: "columns is-multiline features"
  }, [_vm._l((_vm.region.sslPorts), function(o) {
    return _c('div', {
      staticClass: "column is-half-mobile"
    }, [_c('div', {
      staticClass: "box-container"
    }, [_c('div', {
      staticClass: "element-box-container is-best",
      on: {
        "click": function($event) {
          return _vm.selectPort(o, true)
        }
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v("Recommended")]), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o))]), _c('br'), _c('span', {
      staticClass: "subname"
    }, [_vm._v("SSL")])])])])
  }), _vm._l((_vm.region.alternativePorts), function(o) {
    return _c('div', {
      staticClass: "column is-half-mobile"
    }, [_c('div', {
      staticClass: "box-container"
    }, [_c('div', {
      staticClass: "element-box-container",
      on: {
        "click": function($event) {
          return _vm.selectPort(o, false)
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o))]), _c('br'), _c('span', {
      staticClass: "subname"
    }, [_vm._v("TCP")])])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Select a pool port")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_c('span', [_vm._v("You may select any port, this will not affect your mining performance, it depends on your preference or can be used to prevent network restrictions on specific ports.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e41d0b7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_port.vue
// module id = 387
// module chunks = 1